/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BookingScheduleContainer } from "../../containers";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { APPOINTMENT_ERROR_CODE, ASSIGNED_BOOKING_TYPE, BOOKING_FLOW_TYPE, CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import ExpressBookingScheduleContainer from "../../containers/BookingScheduleContainer/ExpressBookingScheduleContainer";
import { useAppointmentCreateV2 } from "../../../services/create-appointment-v2/create-appointment-v2.service";

const SelectedTimeUnavailableModal = () => {
  const { closeModal, appointmentErrorCode, setAppointmentErrorCode, openModal, source } = useModal();
  // eslint-disable-next-line no-unused-vars
  const [activeStep, setActiveStep] = useState<number>(0);
  const [appointmentTime, setAppointmentsTime] = useState<string>("");
  const { createAppointmentV2, appointmentCreatedV2 } = useAppointmentCreateV2();
  const { setAppointmentTypeIndicator, setBookingAppointmentType } = useBookingAppointmentTypeStore();
  const {
    appointmentForm,
    setPromoCodeData,
    resetCurrentBookingStep,
    setCurrentStep,
  } = useAppointmentStore();

  const handleCloseModal = ()=>{
    setCurrentStep(5);
    openModal(MODALS.CANCEL_BOOK_A_VISIT);
  };

  const handleConfirmBooking = () => {
    createAppointmentV2();
  };


  const handleCtaClick = ()=>{
    handleConfirmBooking();
  };

  const getStepDetail = (step: number) => {
    switch (step) {
    case 0:
      return (
        <BookingScheduleContainer />
      );
    case 1:
      return (
        <ExpressBookingScheduleContainer />
      );
    default:
      return null;
    }
  };

  useEffect(() => {
    if (appointmentErrorCode === APPOINTMENT_ERROR_CODE.EXPRESS_BOOKING_ERROR || source === BOOKING_FLOW_TYPE.DEDICATED_EXPRESS_FLOW) {
      setAppointmentTypeIndicator(ASSIGNED_BOOKING_TYPE.EXPRESS_BOOKING);
      setBookingAppointmentType(CREATE_BOOKING_TYPE.EXPRESS_BOOKING);
      setActiveStep(1);
    }
    appointmentForm?.time && setAppointmentsTime(appointmentForm?.time);
  }, []);

  useEffect(() => {
    if (appointmentCreatedV2) {
      if (appointmentCreatedV2.slotUnavailable) {
        setAppointmentErrorCode(appointmentCreatedV2?.messages[0]?.split(":")[0].toLowerCase());
        openModal(MODALS.SELECTED_TIME_UNAVAILABLE);

        return;
      }
      setAppointmentErrorCode("");
      resetCurrentBookingStep();
      closeModal();
      openModal(MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL);
      // to reset the promocode state to default
      setPromoCodeData([]);
    }
  }, [appointmentCreatedV2]);

  return (
    <div className="h-full flex flex-col gap-3 justify-between px-3">
      <div className="w-full flex justify-between">
        <ArrowBackIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="flex flex-col gap-2 items-center bg-gv-yellow-light rounded-lg p-2 mx-4">
        <div className="flex flex-col items-center gap-1">
          <div className="font-semibold text-xl">
            Oops!
          </div>
          <div className="text-sm text-center">
          The time you chose is no longer available. No worries—pick a new time to continue.
          </div>
        </div>
      </div>
      <div className="h-full flex flex-col gap-2 items-center
      justify-between min-h-0 overflow-y-auto !w-full px-2 scrollbar-thin">
        {getStepDetail(activeStep)}
      </div>
      <div className="flex flex-col gap-2 pb-1 pt-1.5 mt-2">
        <StyledBookingFlowButton
          color="primary"
          disabled={appointmentForm?.time === appointmentTime}
          size="small"
          className="w-full"
          onClick={handleCtaClick}
        >
          {"Continue"}
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default SelectedTimeUnavailableModal;
